import React, { useRef } from "react";
import useLang from "Shared/hooks/useLanguage";

const ImagesTab = () => {
  const { t } = useLang();
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div>
      <h5 className="fw-bold text-gray-800 mb-2">{t("Microscopic images")}</h5>
      <p className="text-gray-600 mb-4">
        {t(
          "Attach whole-slide images, macro photos, or annotated microscopic captures to include in the final report."
        )}
      </p>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,.pdf"
        multiple
        className="d-none"
        onChange={() => {
          /* UI-only until API is wired */
        }}
      />
      <div
        role="button"
        tabIndex={0}
        className="d-flex flex-column align-items-center justify-content-center rounded-3 py-10 px-4"
        style={{
          border: "2px dashed #d1d5db",
          backgroundColor: "#fafafa",
          cursor: "pointer",
        }}
        onClick={() => fileInputRef.current?.click()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click();
        }}
      >
        <i className="bi bi-image text-gray-400" style={{ fontSize: "2.5rem" }} />
        <div className="fw-semibold text-gray-700 mt-3">
          {t("Click to add microscopic images")}
        </div>
        <div className="text-gray-500 fs-7 mt-1 text-center">
          {t("Aperio ScanScope exports, macro photos, annotated slides")}
        </div>
      </div>
    </div>
  );
};

export default ImagesTab;
